<script lang="ts">
    import { Col, TabContent, TabPane } from "sveltestrap";
    import { BasicTabsContent, BasicTabsContent1, BasicTabsContent2, ColorTab } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
</script>
<Col xl="6" lg="12" class="xl-100 box-col-12">
    <Card cardHeaderprops="pb-0">
        <div slot="customheader">
          <h5 class="pull-left">{ColorTab}</h5>
        </div>
        <div slot="contentbody">
          <TabContent pills class="nav-primary tabbed-card">
              <TabPane tabId="Home" tab="Home" active>
                  <p class="mb-0 m-t-30">{BasicTabsContent}</p>
              </TabPane>
              <TabPane tabId="Profile" tab="Profile">
                  <p class="mb-0 m-t-30">{BasicTabsContent1}</p>
              </TabPane>
              <TabPane tabId="Contact" tab="Contact">
                  <p class="mb-0 m-t-30">{BasicTabsContent2}</p>
              </TabPane>
          </TabContent>
        </div>
    </Card>
</Col>
          